import { z } from "zod";

// Wire format the remote-grader UI publishes when a human submits a grade.
// @see apps/remote-grader/src/features/grading/schemas/gradingSubmission.ts (canonical source)
const QuestionResultSchema = z.object({
	questionId: z.string().min(1),
	response: z.unknown(),
	responseTime: z.number().int().nonnegative(),
});

const AlertsByAngleSchema = z.record(z.string(), z.array(z.string()));

export const GradingSubmissionSchema = z.object({
	schemaVersion: z.literal(1),
	requestId: z.string().uuid(),
	correlationId: z.string().uuid(),
	publishedAt: z.string(),
	status: z.enum(["assigned", "completed"]),
	updatedBy: z.string().min(1),
	results: z.array(QuestionResultSchema),
	alerts: AlertsByAngleSchema.default({}),
});

export type GradingSubmission = z.infer<typeof GradingSubmissionSchema>;
